import { getRuntimeConfig } from '../runtime-config';
import { API_BASE_URL } from './api-di-tokens';
const baseUrlFactory = () => getRuntimeConfig().apiBaseUrl;
const ɵ0 = baseUrlFactory;
export const BASE_URL_PROVIDER = { provide: API_BASE_URL, useFactory: baseUrlFactory };
export { ɵ0 };
